const entityName = 'stats';

const statModule = {
  state: {},
  mutations: {},
  actions: {
    fetchAll: (context) => {
      const url = entityName;
      return context.dispatch('getAllEntity', {url, entityName})
    },
    postStat: (context, stat) => {
      const payload = {
        url: entityName,
        entityName: entityName,
        entity: stat
      };
      return context.dispatch('postEntity', payload)
    },
    updateStat: (context, stat) => {
      const payload = {
        url: entityName + '/' + stat._id,
        entityName: entityName,
        entity: stat
      };
      return context.dispatch('putEntity', payload)
    },
    removeStat: (context, stat) => {
      const payload = {
        url: entityName + '/' + stat._id,
        entityName: entityName,
        entity: stat
      };
      return context.dispatch('deleteEntity', payload)
    },
  },
  getters: {}
};

export default statModule;
